import isTypedArrayMember from '@/common/utils/typescript/isTypedArrayMember'

import type { UserAuthRole } from '@/client/services/userRole/types'

import type { UserLike } from './types'

export const SUSPENDED_ROLES: UserAuthRole[] = [
  'user:blocked',
  'user:blocked:community',
  'user:rejected',
]

export const UNAPPROVED_ROLES: UserAuthRole[] = SUSPENDED_ROLES.concat('user:unapproved')

export function isUserSuspended(user: UserLike): boolean {
  return user.roles != null && user.roles?.some(item => isTypedArrayMember(item, SUSPENDED_ROLES))
}
